import { render, staticRenderFns } from "./recipe.vue?vue&type=template&id=ef7d669e&scoped=true&"
import script from "./recipe.vue?vue&type=script&lang=js&"
export * from "./recipe.vue?vue&type=script&lang=js&"
import style0 from "./recipe.vue?vue&type=style&index=0&id=ef7d669e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d669e",
  null
  
)

export default component.exports